import React from "react";
import SearchField from "../SearchField/SearchField";
import useUSPosition from "../../hooks/useUSPosition";
import useUSUndo from "../../hooks/useUSUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";

const PositionsUSAPackaging = ({ clearfield }) => {
  // Load context values
  const { USposition, setUSposition, setUSpositionData } = useUSPosition();
  const { positionEdits, editID, setEditID, undoList } = useUSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEdits,
      editID,
      setEditID,
      setUSposition,
      setUSpositionData,
      addEdits,
      undoList,
      origin,
      destination
    );
  };

  return (
    <fieldset>
      <legend>Packaging:</legend>
      <div className='form-group'>
        <label>BagSize:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getbagsizes'
          value={USposition.bagSize || ""}
          valueName='bagSize'
          valueID='bagSizeID'
          customplaceholder='bagSize'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "bagSize", "bagSize");
          }}
          clearfield={clearfield}
        />
      </div>
      <div className='form-group'>
        <label>Marks:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getbagmarktypes'
          value={USposition.bagMarkType || ""}
          valueName='bagMarkType'
          valueID='bagMarkTypeID'
          customplaceholder='bagMarks...'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "bagMarkType", "bagMarkType");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default PositionsUSAPackaging;
